import store from '@/components/store'

class WebSocketService {
  static instance = null;

  // 用户筛选参数
  selectedUserAccount = null;

  constructor(url) {
    if (WebSocketService.instance && WebSocketService.instance.isConnected) {
      console.log('WebSocket 已有连接，复用现有实例')
      return WebSocketService.instance
    }

    if (WebSocketService.instance) {
      console.log('清理旧的 WebSocket 实例')
      WebSocketService.instance.disconnect(true)
    }

    const token = store.getters['globalUserInfo/token']
    const tokenValue = token ? token.replace('Bearer ', '') : ''

    // 默认选中的用户账号为当前登录用户
    this.selectedUserAccount = store.getters['globalUserInfo/userAccount'] || null

    this.url = url || this.generateWebSocketUrl(tokenValue)

    this.socket = null
    this.isConnected = false
    this.onMessageCallbacks = []
    this.dataHandlers = {}
    this.reconnectInterval = null
    this.reconnectAttempts = 0
    this.maxReconnectAttempts = 10

    WebSocketService.instance = this
    this.connect()
  }

  generateWebSocketUrl(token) {
    const isProduction = window.location.protocol === 'https:'
    if (isProduction) {
      return `wss://gyfcdyjq.cn/wss?token=${token}`
    } else {
      return `ws://${window.location.hostname}:10001/ws?token=${token}`
    }
  }

  connect() {
    if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
      console.log('WebSocket 已连接或正在连接，跳过')
      return
    }

    if (this.socket) {
      this.socket.close()
      this.socket = null
    }

    const token = store.getters['globalUserInfo/token']
    if (!token) {
      console.log('Token 为空，不建立 WebSocket 连接')
      this.clearReconnect()
      return
    }

    const tokenValue = token.replace('Bearer ', '')
    this.url = this.generateWebSocketUrl(tokenValue)
    console.log('WebSocket 连接地址:', this.url)

    this.socket = new WebSocket(this.url)

    this.socket.onopen = () => {
      this.isConnected = true
      this.reconnectAttempts = 0
      console.log('WebSocket 连接成功')
      sessionStorage.setItem('webSocketStatus', JSON.stringify(true))
      this.clearReconnect()
      if (this.onOpenCallback) {
        this.onOpenCallback()
      }
      // 连接成功后，发送一次用户参数
      this.sendUserParams()
    }

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data)
        this.onMessageCallbacks.forEach(callback => callback(data))
        Object.keys(this.dataHandlers).forEach(handlerKey => {
          if (data[handlerKey]) {
            this.dataHandlers[handlerKey](data[handlerKey])
          }
        })
      } catch (error) {
        console.error('解析 WebSocket 消息失败:', error)
      }
      this.checkToken()
    }

    this.socket.onclose = () => {
      this.isConnected = false
      console.log('WebSocket 连接已关闭')
      sessionStorage.setItem('webSocketStatus', JSON.stringify(false))
      this.socket = null
      this.tryReconnect()
      if (this.onCloseCallback) {
        this.onCloseCallback()
      }
    }

    this.socket.onerror = (error) => {
      console.error('WebSocket 发生错误:', error)
    }
  }

  /**
   * 设置用户筛选参数
   * @param {string} selectedUserAccount - 选中的用户账号（空字符串表示全部/当前用户）
   */
  setUserParams(selectedUserAccount) {
    this.selectedUserAccount = selectedUserAccount || null
    console.log('WebSocket 用户参数已更新:', {
      selectedUserAccount: this.selectedUserAccount
    })
    // 立即发送更新后的参数
    this.sendUserParams()
  }

  /**
   * 发送用户参数给后端
   */
  sendUserParams() {
    if (!this.isConnected || !this.socket) {
      return
    }

    const params = {
      type: 'user_filter',
      selectedUserAccount: this.selectedUserAccount
    }

    try {
      this.socket.send(JSON.stringify(params))
    } catch (error) {
      console.error('发送用户参数失败:', error)
    }
  }

  tryReconnect() {
    const token = store.getters['globalUserInfo/token']
    if (!token) {
      console.log('Token 为空，停止重连')
      this.clearReconnect()
      return
    }
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      if (!this.reconnectInterval) {
        this.reconnectInterval = setInterval(() => {
          this.reconnectAttempts++
          console.log(`尝试重新连接 WebSocket... (${this.reconnectAttempts}/${this.maxReconnectAttempts})`)
          this.connect()
        }, 3000)
      }
    } else {
      this.clearReconnect()
    }
  }

  clearReconnect() {
    if (this.reconnectInterval) {
      clearInterval(this.reconnectInterval)
      this.reconnectInterval = null
    }
  }

  onOpen(callback) {
    this.onOpenCallback = callback
  }

  onClose(callback) {
    this.onCloseCallback = callback
  }

  onMessage(callback) {
    this.onMessageCallbacks.push(callback)
  }

  registerDataHandler(key, handler) {
    this.dataHandlers[key] = handler
  }

  send(data) {
    if (this.socket && this.isConnected) {
      this.socket.send(JSON.stringify(data))
    } else {
      console.warn('WebSocket 未连接')
    }
  }

  disconnect(isInternal = false) {
    if (this.socket) {
      this.socket.close()
      this.socket = null
      this.isConnected = false
      sessionStorage.setItem('webSocketStatus', JSON.stringify(false))
      console.log('WebSocket 连接已手动断开')
    }
    this.clearReconnect()

    if (!isInternal) {
      WebSocketService.instance = null
    }
  }

  checkToken() {
    const token = store.getters['globalUserInfo/token']
    if (!token) {
      console.log('Token 已失效，断开 WebSocket 连接')
      this.disconnect(true)
    }
  }

  getConnectionStatus() {
    return this.isConnected
  }
}

export default WebSocketService
